import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import MainForwadedQuiz from "../../components/quiz/MainForwadedQuiz";
import { fetchForwardedById } from "../../redux/actions/fowardQuestionActionCreators";
import MainQuiz from "../../components/quiz/MainQuiz";
import { useHistory } from "react-router-dom";

// const data = {
//   "answers": {
//     "193": 0,
//     "196": 518,
//     "197": 521,
//     "198": 524,
//     "199": 527
//   },
//   "description": "I'm testing",
//   "description_fr": "i'm testing",
//   "id": 170,
//   "identifier": "a573cb4f-34e2-451c-8858-62d3906b3afc",
//   "pourcentage": 100.0,
//   "quiz_id": 170,
//   "timestamp": "2023-06-01T15:35:41.565504",
//   "title": "Testing",
//   "title_fr": "testing",
//   "usecases": [
//     {
//       "id": 175,
//       "questions": [
//         {
//           "choices": [
//             {
//               "id": 517,
//               "title": "one single account for the whole organization",
//               "title_fr": "un seul compte pour l'ensemble de l'organisation"
//             },
//             {
//               "id": 518,
//               "title": "multiple but less than ten",
//               "title_fr": "multiple mais inférieur à dix"
//             },
//             {
//               "id": 519,
//               "title": "dozens of accounts",
//               "title_fr": "des dizaines de comptes"
//             }
//           ],
//           "id": 196,
//           "title": "How many accounts do you have ?",
//           "title_fr": "Combien de comptes avez-vous ?"
//         },
//         {
//           "choices": [
//             {
//               "id": 520,
//               "title": "yes",
//               "title_fr": "oui"
//             },
//             {
//               "id": 521,
//               "title": "no",
//               "title_fr": "non"
//             },
//             {
//               "id": 522,
//               "title": "Not all accounts are linked to the organization",
//               "title_fr": "Tous les comptes ne sont pas liés à l'organisation"
//             }
//           ],
//           "id": 197,
//           "title": "Do you use Organization to manage your accounts ? ",
//           "title_fr": "Utilisez-vous Organization pour gérer vos comptes ? "
//         },
//         {
//           "choices": [
//             {
//               "id": 523,
//               "title": "yes",
//               "title_fr": "oui"
//             },
//             {
//               "id": 524,
//               "title": "the seperation between accounts is based on other criterias",
//               "title_fr": "la séparation entre les comptes est basée sur d'autres critères"
//             },
//             {
//               "id": 525,
//               "title": "seperation is not very clear",
//               "title_fr": "la séparation n'est pas très claire"
//             }
//           ],
//           "id": 198,
//           "title": "Are your accounts seperated on envionment basis ? (ie prod / staging / test)",
//           "title_fr": "Vos comptes sont-ils séparés en fonction de l'environnement ? (c'est-à-dire production, mise en scène, test)"
//         },
//         {
//           "choices": [
//             {
//               "id": 526,
//               "title": "yes",
//               "title_fr": "oui"
//             },
//             {
//               "id": 527,
//               "title": "no",
//               "title_fr": "non"
//             }
//           ],
//           "id": 199,
//           "title": "Do you have accounts only dedicated to production environement only ? ",
//           "title_fr": "Avez-vous des comptes uniquement dédiés à l'environnement de production ? "
//         }
//       ],
//       "title": "Cloud Account Management",
//       "title_fr": "Gestion des comptes dans le cloud"
//     },
//     {
//       "id": 167,
//       "questions": [
//         {
//           "choices": [
//             {
//               "id": 507,
//               "title": "I don't know, we'll see when that happens",
//               "title_fr": "Je ne sais pas, nous verrons quand cela se produira"
//             },
//             {
//               "id": 508,
//               "title": "we have an alternative to a secure communication channel that has already been tested and in place",
//               "title_fr": "nous avons une alternative à un canal de communication sécurisé qui a déjà été testée et en place"
//             },
//             {
//               "id": 509,
//               "title": "No problem, we will create a WhatsApp group channel",
//               "title_fr": "pas de problème, nous allons créer une chaîne de groupe WhatsApp"
//             },
//             {
//               "id": 510,
//               "title": "we have an alternative but it has never been tested",
//               "title_fr": "nous avons une alternative mais elle n'a jamais été testée"
//             }
//           ],
//           "id": 193,
//           "title": "If you have a cyber incident and all your mailing and communication tools are down (outook, teams, workspaces,...), how will you communicate with your team ? ",
//           "title_fr": "Si vous êtes victime d'un cyberincident et que tous vos outils de messagerie et de communication sont en panne (Outlook, équipes, espaces de travail,...), comment communiquerez-vous avec votre équipe ? "
//         }
//       ],
//       "title": "Cyber Incident Preparedness",
//       "title_fr": "Préparation aux cyberincidents"
//     }
//   ],
//   "user_questions": [
//     {
//       "answered": false,
//       "choice_id": null,
//       "forwarded_to": "emna.kallel@zeta-box.com",
//       "question_id": 193
//     }
//   ],
//   "version": 1
// }

const IncompleteQuiz = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.forwardQuiz.selected);
  const params = useParams();
  const history= useHistory()

  useEffect(() => {
    dispatch(fetchForwardedById(params.forwardId, history));
  }, [dispatch, params.forwardId]);
  return (
    <>{data ? <MainForwadedQuiz data={data} initialPayload={data?.answers?.questions} initialThreshold={data?.answers?.usecases}/> : null}</>
  );
};

export default IncompleteQuiz;
